import { render, staticRenderFns } from "./ClassStudents.vue?vue&type=template&id=7a3aa108&scoped=true&"
import script from "./ClassStudents.vue?vue&type=script&lang=js&"
export * from "./ClassStudents.vue?vue&type=script&lang=js&"
import style0 from "./ClassStudents.vue?vue&type=style&index=0&id=7a3aa108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3aa108",
  null
  
)

export default component.exports